import React, { useState, useEffect, useCallback } from 'react';
import HeroSlide from './HeroSlide';
import ShippouEffect from './visualEffects/ShippouEffect';
import WaveEffect from './visualEffects/WaveEffect';
import FujiEffect from './visualEffects/FujiEffect';
import { trackSliderInteraction } from '../utils/analytics';

const HeroSlider = ({ slides }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  // 次のスライドへ
  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  }, [slides.length]);

  // 前のスライドへ
  const prevSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  }, [slides.length]);

  // 自動スライド
  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      nextSlide();
    }, 18000); // 18秒ごとにスライド切り替え

    return () => clearInterval(interval);
  }, [isAutoPlaying, nextSlide]);

  // サムネイルのレンダリング
  const renderThumbnail = (slide) => {
    const thumbnailStyles = {
      width: '100%',
      height: '100%',
      position: 'relative',
      overflow: 'hidden',
    };

    switch (slide.backgroundType) {
      case 'animation':
        // アニメーションの静止版を表示
        const EffectComponent = 
          slide.visualType === 'shippou' ? ShippouEffect :
          slide.visualType === 'wave' ? WaveEffect :
          slide.visualType === 'fuji' ? FujiEffect : null;
        
        return EffectComponent ? (
          <div style={thumbnailStyles}>
            <div style={{ transform: 'scale(0.1)', transformOrigin: 'top left', width: '1000%', height: '1000%' }}>
              <EffectComponent />
            </div>
          </div>
        ) : null;

      case 'image':
        return (
          <div style={{
            ...thumbnailStyles,
            backgroundImage: `url(${slide.backgroundImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }} />
        );

      case 'video':
        return (
          <video
            muted
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          >
            <source src={slide.backgroundVideo} type="video/mp4" />
          </video>
        );

      case 'gradient':
        return (
          <div style={{
            ...thumbnailStyles,
            background: slide.backgroundGradient,
          }} />
        );

      default:
        return null;
    }
  };

  const styles = {
    sliderWrapper: {
      display: 'flex',
      flexDirection: 'column',
    },
    sliderContainer: {
      position: 'relative',
      width: '100%',
      height: '100vh',
      overflow: 'hidden',
      background: '#ffffff',
    },
    slidesWrapper: {
      position: 'relative',
      width: '100%',
      height: '100%',
    },
    navigationButton: {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      background: 'rgba(255, 255, 255, 0.3)',
      border: '2px solid rgba(255, 255, 255, 0.5)',
      color: '#ffffff',
      width: '50px',
      height: '50px',
      borderRadius: '50%',
      cursor: 'pointer',
      fontSize: '24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 40,
      transition: 'all 0.3s',
      backdropFilter: 'blur(5px)',
    },
    prevButton: {
      left: '30px',
    },
    nextButton: {
      right: '30px',
    },
    thumbnailsSection: {
      backgroundColor: '#f9fafb',
      padding: '30px 20px',
      borderTop: '1px solid #e5e7eb',
    },
    thumbnailsContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
      display: 'flex',
      justifyContent: 'center',
      gap: '20px',
      flexWrap: 'wrap',
    },
    thumbnail: {
      width: '200px',
      height: '120px',
      borderRadius: '8px',
      overflow: 'hidden',
      cursor: 'pointer',
      border: '3px solid #e5e7eb',
      transition: 'all 0.3s',
      position: 'relative',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    },
    thumbnailActive: {
      border: '3px solid #2563eb',
      transform: 'scale(1.05)',
      boxShadow: '0 4px 12px rgba(37, 99, 235, 0.3)',
    },
    thumbnailOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(0, 0, 0, 0.4)',
      transition: 'all 0.3s',
    },
    thumbnailOverlayActive: {
      background: 'rgba(0, 0, 0, 0)',
    },
  };

  return (
    <div style={styles.sliderWrapper}>
      <style>
        {`
          @media (max-width: 768px) {
            .nav-button-mobile {
              width: 40px !important;
              height: 40px !important;
              font-size: 18px !important;
            }
            .prev-button-mobile {
              left: 15px !important;
            }
            .next-button-mobile {
              right: 15px !important;
            }
            .thumbnails-section-mobile {
              padding: 20px 10px !important;
            }
            .thumbnails-container-mobile {
              gap: 10px !important;
              overflow-x: auto !important;
              justify-content: flex-start !important;
              flex-wrap: nowrap !important;
              padding: 0 10px !important;
            }
            .thumbnail-mobile {
              width: 140px !important;
              height: 80px !important;
              flex-shrink: 0 !important;
            }
              h1{
              font-size: 38px !important;
              }
              h3{
              font-size: 24px !important;
              }
              .slider-Container{
              height: 60vh !important;
              }
        `}
      </style>

      {/* スライド表示エリア */}
      <div style={styles.sliderContainer} className="slider-Container">
        <div style={styles.slidesWrapper}>
          {slides.map((slide, index) => (
            <HeroSlide
              key={slide.id}
              slideData={slide}
              isActive={index === currentSlide}
            />
          ))}
        </div>

        {/* 前へボタン */}
        <button
          onClick={() => {
            prevSlide();
            setIsAutoPlaying(false);
            // Analytics追跡
            trackSliderInteraction('prev', currentSlide);
          }}
          style={{ ...styles.navigationButton, ...styles.prevButton }}
          className="nav-button-mobile prev-button-mobile"
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.5)';
            e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.3)';
            e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
          }}
        >
          ‹
        </button>

        {/* 次へボタン */}
        <button
          onClick={() => {
            nextSlide();
            setIsAutoPlaying(false);
            // Analytics追跡
            trackSliderInteraction('next', currentSlide);
          }}
          style={{ ...styles.navigationButton, ...styles.nextButton }}
          className="nav-button-mobile next-button-mobile"
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.5)';
            e.currentTarget.style.transform = 'translateY(-50%) scale(1.1)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'rgba(255, 255, 255, 0.3)';
            e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
          }}
        >
          ›
        </button>
      </div>

      {/* サムネイルナビゲーション（メインビジュアルの外） */}
      <div style={styles.thumbnailsSection} className="thumbnails-section-mobile">
        <div style={styles.thumbnailsContainer} className="thumbnails-container-mobile">
          {slides.map((slide, index) => (
            <div
              key={slide.id}
              onClick={() => {
                setCurrentSlide(index);
                setIsAutoPlaying(false);
                // Analytics追跡
                trackSliderInteraction('thumbnail', index);
              }}
              style={{
                ...styles.thumbnail,
                ...(index === currentSlide ? styles.thumbnailActive : {}),
              }}
              className="thumbnail-mobile"
              onMouseEnter={(e) => {
                if (index !== currentSlide) {
                  e.currentTarget.style.transform = 'scale(1.05)';
                }
              }}
              onMouseLeave={(e) => {
                if (index !== currentSlide) {
                  e.currentTarget.style.transform = 'scale(1)';
                }
              }}
            >
              {renderThumbnail(slide)}
              <div
                style={{
                  ...styles.thumbnailOverlay,
                  ...(index === currentSlide ? styles.thumbnailOverlayActive : {}),
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HeroSlider;